import { styled } from '@mui/material/styles';
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import { Box } from "@mui/material";

// Enhanced Accordion Summary with custom styles
export const AccordionSummary = styled(MuiAccordionSummary)(() => ({
  backgroundColor: "rgba(0, 0, 0, .05)",
  borderBottom: "1px solid rgba(0, 0, 0, .125)",
  marginBottom: -1,
  minHeight: 56,
  '&.Mui-expanded': {
    minHeight: 56,
  },
  '& .MuiAccordionSummary-content': {
    '&.Mui-expanded': {
      margin: "12px 0",
    },
  },
}));

// Container for the accordion
export const AccordionRoot = styled(Box)(() => ({
  width: "100%",
}));

// Heading typography in the accordion
export const AccordionHeading = styled('div')(({ theme }) => ({
  fontSize: theme.typography.pxToRem(15),
})); 